import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import { CheckList, CheckListItem } from 'components/CheckList'
import { FlexContainer, FlexItem } from 'components/Flex'
import './styles.sass'

@scrollToTop
@observer
export default class TaxYearsStep extends React.Component {
  render () {
    return (
      <div className="tax-years-step">
        <FlexContainer direction="column" alignItems="center">
          <FlexItem>
            <CheckList>
              {this.props.step.years.map((year) => (
                <CheckListItem
                  checked={year.selected}
                  onChange={newVal => year.setSelected(newVal)}
                  key={year.year}
                >
                  {year.year}
                </CheckListItem>
              ))}
            </CheckList>
          </FlexItem>
        </FlexContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/TaxYears/index.jsx